import { TableColumn } from '@/components/Table';

interface DataRowTickets {
  name: string;
  batch: string;
  unitValue: string;
  amount: string;
  amountSold: string;
}

export const columnsTickets: TableColumn<DataRowTickets>[] = [
  {
    name: 'Nome do ingresso',
    selector: row => row.name,
    width: '35%',
  },
  {
    name: 'Lote',
    selector: row => row.batch,
    width: '35%',
  },
  {
    name: 'Qtd',
    selector: row => row.amount,
    width: '10%',
  },
  {
    name: 'Valor',
    selector: row => row.unitValue,
    width: '10%',
  },
  {
    name: 'Disponível',
    selector: row => row.amountSold,
    width: '10%',
  },
];
